<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <div class="row">
                <h5 class="card-title text-primary mx-auto">Affiliate Links Settings</h5>
            </div>
            <div class="row">

            </div>
            <div class="row">
                <a href="https://creditfixrrreports.com" target="_blank" class="btn-sm btn-primary mx-auto mb-1">
                    <i data-feather="external-link"></i>
                    <span>
                        {{ localizationStore.translate('creditfixrrreports.referral.button.text') }}
                    </span>
                </a>
                <a href="https://bit.ly/CreditfixrrTechnologyInc" target="_blank" class="btn-sm btn-primary mx-auto mb-1">
                    <i data-feather="external-link"></i>
                    <span>
                        {{localizationStore.translate('smartcredit.referral.button.text')}}
                    </span>
                </a>
                <a href="https://portal.myfreescorenow.com/referenceAffiliateRequest/R2pVaGFJZXY=" target="_blank" class="btn-sm btn-primary mx-auto mb-1">
                    <i data-feather="external-link"></i>
                    <span>
                        {{ localizationStore.translate('myfreescorenow.referral.button.text') }}
                    </span>
                </a>
                <a href="https://partner.idiq.com/inviteapartner?zid=34102" target="_blank" class="btn-sm btn-primary mx-auto mb-1">
                    <i data-feather="external-link"></i>
                    <span>
                        {{ localizationStore.translate('IDIQ.referral.button.text') }}
                    </span>
                </a>
            </div>
            <!-- {{ route('company.affiliate_setting.update') }} -->
            <div class="row mx-auto">
                <div v-if="businessStore.business.settings" class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="creditfixrrreports">
                                    {{ localizationStore.translate('affiliate.creditfixrrreports') }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :placeholder="localizationStore.translate('affiliate.creditfixrrreports.placeholder')"
                                    id="creditfixrrreports"
                                    name="creditfixrrreports"
                                    :data-validation-required-message="localizationStore.translate('affiliate.creditfixrrreports.error.message')"
                                    v-model="businessStore.business.settings.affiliate_creditfixrrreports"
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="affiliate_smartcredit">
                                    {{ localizationStore.translate('affiliate.smartcredit') }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :placeholder="localizationStore.translate('affiliate.smartcredit.placeholder')"
                                    id="affiliate_smartcredit"
                                    name="affiliate_smartcredit"
                                    :data-validation-required-message="localizationStore.translate('affiliate.smartcredit.error.message')"
                                    v-model="businessStore.business.settings.affiliate_smartcredit"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="affiliate_myfreescorenow">
                                    {{ localizationStore.translate('affiliate.myfreescorenow.label') }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :placeholder="localizationStore.translate('affiliate.myfreescorenow.placeholder')"
                                    name="affiliate_myfreescorenow"
                                    data-validation-required-message="localizationStore.translate('affiliate.myfreescorenow.error.message')"
                                    v-model="businessStore.business.settings.affiliate_myfreescorenow"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="affiliate_identity">
                                    {{ localizationStore.translate('affiliate.identity') }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :placeholder="localizationStore.translate('affiliate.identity.placeholder')"
                                    id="affiliate_identity"
                                    name="affiliate_identity"
                                    :data-validation-required-message="localizationStore.translate('affiliate.identity.error.message')"
                                    v-model="businessStore.business.settings.affiliate_identity"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="affiliate_myscore">
                                    {{ localizationStore.translate('affiliate.myscore') }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :placeholder="localizationStore.translate('affiliate.myscore.placeholder')"
                                    id="affiliate_myscore"
                                    name="affiliate_myscore"
                                    :data-validation-required-message="localizationStore.translate('affiliate.myscore.error.message')"
                                    v-model="businessStore.business.settings.affiliate_myscore"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <button type="button" class="btn btn-primary mx-auto my-auto" @click="saveAffiliate">{{ localizationStore.translate('save.changes') }}</button>
                    &nbsp;&nbsp;
                    <button type="button" data-dismiss="modal"
                        class="btn btn-outline-secondary mx-auto my-auto">{{ localizationStore.translate('close') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../../stores/LocalizationStore.js'
import axios from 'axios'
export default{
    components:{

    },
    setup(){
        return{
            userStore : useUserStore(),
            businessStore : useBusinessStore(),
            localizationStore : useLocalizationStore(),
        }
    },
    watch: {
    },
    methods:{
        saveAffiliate(){
            const route = this.$router.resolve(
                {
                    name: 'company-affiliate-setting-update',
                }
            );
            axios.put(
                route.href,
                _.pick(
                    this.businessStore.business.settings,
                    [
                        'affiliate_creditfixrrreports',
                        'affiliate_identity',
                        'affiliate_smartcredit',
                        'affiliate_myscore',
                        'affiliate_myfreescorenow'
                    ]
                )
            ).then(({data})=>{
                if(data.error == false){
                    toastr.success(data.message,'Success')
                }else{
                    toastr.success(data.message,'Error')
                }
            })
        }
    }
}
</script>